<template>
  <a class="navbar-item" @click="goTo">
    <slot></slot>
  </a>
</template>
<script>

export default {
  name: 'MenuItem',
  props: {
    link: {
      type: String,
      required: true
    }
  },
  methods: {
    goTo () {
      window.location.assign(this.link)
    }
  }
}
</script>
